import React from 'react';

const Stat = ({ label, value }) => (
  <div className="rounded-xl border border-[var(--fg-line)] bg-[var(--fg-panel-soft)] px-3 py-2">
    <div className="text-[11px] font-semibold uppercase tracking-wide text-[var(--fg-muted)]">{label}</div>
    <div className="mt-1 text-sm font-semibold text-[var(--fg-text)]">{value}</div>
  </div>
);

const FundingAIAdvisorContextPanel = ({ context, loading, client, agencyLabel }) => {
  if (loading) return <p className="text-sm text-[var(--fg-muted)]">Loading advisor context...</p>;
  if (!context) return <p className="text-sm text-[var(--fg-muted)]">Advisor context unavailable.</p>;

  const clientContext = context.clientContext;
  const portfolioContext = context.portfolioContext;

  if (clientContext) {
    const c = clientContext.client || client || {};
    return (
      <div className="space-y-3">
        {agencyLabel ? (
          <div className="rounded-xl border border-dashed border-[var(--fg-line)] px-3 py-2 text-xs text-[var(--fg-muted)]">
            Agency context: {agencyLabel}
          </div>
        ) : null}
        <div>
          <div className="text-base font-semibold text-[var(--fg-text)]">{c.name}</div>
          <div className="text-sm text-[var(--fg-muted)]">{c.status}</div>
        </div>
        <div className="grid gap-2 sm:grid-cols-2">
          <Stat label="Estimated readiness" value={c.readinessScore != null ? `${c.readinessScore}%` : '—'} />
          <Stat label="Documents" value={clientContext.documentStatus || c.documentStatus || '—'} />
          <Stat label="Matches" value={clientContext.matches?.length ?? 0} />
          <Stat label="Submissions" value={clientContext.submissions?.length ?? 0} />
          <Stat label="Deals" value={clientContext.deals?.length ?? 0} />
          <Stat label="Commissions" value={clientContext.commissions?.length ?? 0} />
        </div>
        <p className="text-xs text-[var(--fg-muted)]">{context.advisoryNote}</p>
      </div>
    );
  }

  const p = portfolioContext || {};
  return (
    <div className="space-y-3">
      {agencyLabel ? (
        <div className="rounded-xl border border-dashed border-[var(--fg-line)] px-3 py-2 text-xs text-[var(--fg-muted)]">
          Portfolio mode — {agencyLabel}
        </div>
      ) : null}
      <div className="grid gap-2 sm:grid-cols-2">
        <Stat label="Clients" value={p.clientCount ?? 0} />
        <Stat label="Need documents" value={p.clientsNeedingDocuments?.length ?? 0} />
        <Stat label="Ready for match" value={p.clientsReadyForMatch?.length ?? 0} />
        <Stat label="Submission follow-up" value={p.submissionsNeedingFollowUp?.length ?? 0} />
        <Stat label="Overdue deal tasks" value={p.dealsWithOverdueTasks?.length ?? 0} />
        <Stat label="Clawback monitoring" value={p.commissionsNearingClawbackRisk?.length ?? 0} />
      </div>
      <p className="text-xs text-[var(--fg-muted)]">{context.advisoryNote}</p>
    </div>
  );
};

export default FundingAIAdvisorContextPanel;
